<template>
  <div>
    <v-row
      class="ma-0"
      justify="space-between"
      align="center"
    >
      <h1 class="ma-2">
        คิวประจำวันที่
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on }">
            <span
              style="cursor: pointer;"
              v-on="on"
            >
              {{ formattedDate }}
            </span>
          </template>
          <v-date-picker
            v-model="date"
            landscape
            next-icon="fas fa-chevron-right"
            prev-icon="fas fa-chevron-left"
            color="orange"
            @change="search"
          />
        </v-menu>
      </h1>
      <v-btn
        large
        color="orange"
        @click="reservationDialog = true"
      >
        <v-icon
          left
          small
        >
          fas fa-book
        </v-icon>
        จองคิว
      </v-btn>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="5"
        md="4"
      >
        <v-card>
          <v-card-title>
            พนักงาน
          </v-card-title>
          <v-list>
            <v-list-item
              v-for="employee in employees"
              :key="employee._id"
              :input-value="lookUpEmployee === employee._id"
              @click="onSelectEmployee(employee._id, employee.firstName)"
            >
              <v-list-item-avatar color="orange">
                <v-img
                  v-if="employee.image"
                  :src="employee.image"
                />
                <v-icon
                  v-else
                  small
                >
                  fas fa-user
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                {{ employee.firstName }} {{ employee.lastName }} <br>
                {{ employee.gender }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="7"
        md="8"
      >
        <v-card>
          <v-card-title>
            คิวของ {{ lookUpEmployeeName }}
          </v-card-title>
          <v-tabs
            v-if="lookUpEmployeeName"
            grow
            color="orange"
          >
            <v-tab>
              <v-icon
                left
                small
              >
                fas fa-credit-card
              </v-icon>
              บริการที่รอคิดเงิน
            </v-tab>
            <v-tab>
              <v-icon
                left
                small
              >
                fas fa-clock
              </v-icon>
              บริการที่รอลูกค้ามารับบริการ
            </v-tab>
            <v-tab-item>
              <div
                v-if="employeeFinishedQueue.length === 0"
                class="py-5"
              >
                <center>
                  <h3 class="font-weight-thin">
                    ยังไม่มีข้อมูล
                  </h3>
                </center>
              </div>
              <v-list
                v-else
                three-line
              >
                <v-list-item
                  v-for="queue in employeeFinishedQueue"
                  :key="queue._id"
                  dense
                >
                  <v-list-item-avatar color="orange">
                    <v-img
                      v-if="queue.customer.image"
                      :src="queue.customer.image"
                    />
                    <v-icon
                      v-else
                      small
                    >
                      fas fa-user
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      คุณ {{ queue.customer.firstName }}
                      {{ queue.customer.lastName }}
                      [ {{ queue.startDate | unixToTime }} - {{ queue.endDate | unixToTime }} ]
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      บริการคอร์สที่ซื้อ :
                      <span
                        v-for="(course, index) in queue.courses"
                        :key="course._id"
                      >
                        {{ course.name }}
                        <span v-if="index !== queue.courses.length - 1">
                          ,
                        </span>
                      </span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      บริการที่ซื้อ :
                      <span
                        v-for="(service, index) in queue.services"
                        :key="service._id"
                      >
                        {{ service.name }}
                        <span v-if="index !== queue.services.length - 1">
                          ,
                        </span>
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      v-if="queue.serviceStatus === 'SERVICED'"
                      icon
                      @click="updateQueueStatus(queue._id, 'serviceStatus', 'PAID')"
                    >
                      <v-icon small>
                        fas fa-credit-card
                      </v-icon>
                    </v-btn>
                    <v-span v-else>
                      จ่ายแล้ว
                    </v-span>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-tab-item>
            <v-tab-item>
              <div
                v-if="employeePendingQueue.length === 0"
                class="py-5"
              >
                <center>
                  <h3 class="font-weight-thin">
                    ยังไม่มีข้อมูล
                  </h3>
                </center>
              </div>
              <v-list
                v-else
                three-line
              >
                <v-list-item
                  v-for="queue in employeePendingQueue"
                  :key="queue._id"
                  dense
                >
                  <v-list-item-avatar color="orange">
                    <v-img
                      v-if="queue.customer.image"
                      :src="queue.customer.image"
                    />
                    <v-icon
                      v-else
                      small
                    >
                      fas fa-user
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      คุณ {{ queue.customer.firstName }}
                      {{ queue.customer.lastName }}
                      [ {{ queue.startDate | unixToTime }} - {{ queue.endDate | unixToTime }} ]
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      บริการคอร์สที่ซื้อ :
                      <span
                        v-for="(course, index) in queue.courses"
                        :key="course._id"
                      >
                        {{ course.name }}
                        <span v-if="index !== queue.courses.length - 1">
                          ,
                        </span>
                      </span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      บริการที่ซื้อ :
                      <span
                        v-for="(service, index) in queue.services"
                        :key="service._id"
                      >
                        {{ service.name }}
                        <span v-if="index !== queue.services.length - 1">
                          ,
                        </span>
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-row>
                      <v-btn
                        icon
                        @click="onRoomDialogOpen(queue._id)"
                      >
                        <v-icon small>
                          fas fa-user-check
                        </v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        @click="updateQueueStatus(queue._id, 'serviceStatus', 'INSERVICE')"
                      >
                        <v-icon small>
                          fas fa-user-times
                        </v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        @click="deleteQueue(queue._id)"
                      >
                        <v-icon small>
                          fas fa-trash
                        </v-icon>
                      </v-btn>
                    </v-row>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-tab-item>
          </v-tabs>
          <v-card-text v-else>
            <center>
              กรุณาเลือกพนักงานเพื่อดูคิว
            </center>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            คิวที่รอการจัดการ
          </v-card-title>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      ชื่อลูกค้า
                    </th>
                    <th class="text-left">
                      บริการคอร์ส
                    </th>
                    <th class="text-left">
                      บริการ
                    </th>
                    <th>
                      เวลาในการบริการ
                    </th>
                    <th>
                      ราคา
                    </th>
                    <th>
                      หมายเหตุ
                    </th>
                    <th>
                      ตัวเลือก
                    </th>
                  </tr>
                </thead>
                <tbody v-if="waitToBookQueue.length > 0">
                  <tr
                    v-for="queue in waitToBookQueue"
                    :key="queue._id"
                  >
                    <td>
                      คุณ
                      {{ queue.customer.firstName }}
                      {{ queue.customer.lastName }}
                    </td>
                    <td>
                      <div v-if="queue.courses.length > 0">
                        <span
                          v-for="(course, index) in queue.courses"
                          :key="course._id"
                        >
                          {{ course.name }}
                          <span v-if="index !== queue.courses.length - 1">
                            ,
                          </span>
                        </span>
                      </div>
                      <span v-else>
                        -
                      </span>
                    </td>
                    <td>
                      <div v-if="queue.services.length > 0">
                        <span
                          v-for="(service, index) in queue.services"
                          :key="service._id"
                        >
                          {{ service.name }}
                          <span v-if="index !== queue.services.length - 1">
                            ,
                          </span>
                        </span>
                      </div>
                      <span v-else>
                        -
                      </span>
                    </td>
                    <td>
                      {{ queue.startDate | unixToTime }} - {{ queue.endDate | unixToTime }}
                    </td>
                    <td>
                      {{ queue.price }}
                    </td>
                    <td>
                      {{ queue.customerMark ? queue.customerMark : '-' }}
                    </td>
                    <td>
                      <v-btn
                        icon
                        @click="onQueueDialogOpen(queue._id, 'bookDialog')"
                      >
                        <v-icon small>
                          fas fa-check
                        </v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        @click="onQueueDialogOpen(queue._id, 'rejectDialog')"
                      >
                        <v-icon small>
                          fas fa-times
                        </v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        @click="deleteQueue(queue._id)"
                      >
                        <v-icon small>
                          fas fa-trash
                        </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="7">
                      <center>ไม่พบข้อมูล</center>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="reservationDialog"
      max-width="600"
    >
      <v-card>
        <v-card-title>
          จองคิวในวันที่ {{ date }}
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col
              cols="12"
              sm="6"
            >
              <v-autocomplete
                v-model="selectedCustomer"
                :items="customers"
                label="ลูกค้า"
                color="orange"
                filled
                item-value="_id"
                item-text="firstName"
                item-color="orange"
              >
                <template v-slot:selection="data">
                  {{ data.item.firstName }} {{ data.item.lastName }}
                </template>
                <template v-slot:item="data">
                  <v-list-item-avatar color="orange">
                    <img
                      v-if="data.item.image"
                      :src="data.item.image"
                    >
                    <v-icon
                      v-else
                      small
                      color="white"
                    >
                      fas fa-user
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ data.item.firstName }}
                      {{ data.item.lastName }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-autocomplete
                v-model="selectedEmployee"
                :items="employees"
                label="พนักงาน"
                filled
                color="orange"
                item-value="_id"
                item-text="firstName"
                item-color="orange"
              >
                <template v-slot:selection="data">
                  {{ data.item.firstName }} {{ data.item.lastName }}
                </template>
                <template v-slot:item="data">
                  <v-list-item-avatar color="orange">
                    <img
                      v-if="data.item.image"
                      :src="data.item.image"
                    >
                    <v-icon
                      v-else
                      small
                      color="white"
                    >
                      fas fa-user
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ data.item.firstName }}
                      {{ data.item.lastName }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col sm="12">
              <v-autocomplete
                v-model="selectedService"
                :items="services"
                item-value="_id"
                item-text="name"
                label="บริการ"
                filled
                multiple
                color="orange"
                item-color="orange"
              >
                <template v-slot:selection="data">
                  <v-chip
                    close
                    close-icon="fas fa-times-circle"
                    :input-value="data.selected"
                    @click="data.select"
                    @click:close="removeService(data.item._id)"
                  >
                    <v-avatar
                      left
                      color="orange"
                    >
                      <v-img
                        v-if="data.item.image"
                        :src="data.item.image"
                      />
                      <v-icon
                        v-else
                        small
                        color="white"
                      >
                        fas fa-spa
                      </v-icon>
                    </v-avatar>
                    {{ data.item.name }} [ {{ data.item.price }} บาท ]
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <v-list-item-avatar>
                    <v-img
                      v-if="data.item.image"
                      :src="data.item.image"
                    />
                    <v-icon
                      v-else
                      small
                      color="white"
                    >
                      fas fa-spa
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ data.item.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ data.item.price }} บาท
                      [ {{ data.item.time }} นาที ]
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col sm="12">
              <v-autocomplete
                v-model="selectedCourse"
                :items="courses"
                item-value="_id"
                item-text="name"
                label="บริการคอร์ส"
                filled
                multiple
                color="orange"
                item-color="orange"
              >
                <template v-slot:selection="data">
                  <v-chip
                    close
                    close-icon="fas fa-times-circle"
                    :input-value="data.selected"
                    @click="data.select"
                    @click:close="removeCourse(data.item._id)"
                  >
                    <v-avatar
                      left
                      color="orange"
                    >
                      <v-img
                        v-if="data.item.image"
                        :src="data.item.image"
                      />
                      <v-icon
                        v-else
                        small
                        color="white"
                      >
                        fas fa-spa
                      </v-icon>
                    </v-avatar>
                    {{ data.item.name }} [ {{ data.item.price }} บาท ]
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <v-list-item-avatar>
                    <v-img
                      v-if="data.item.image"
                      :src="data.item.image"
                    />
                    <v-icon
                      v-else
                      small
                      color="white"
                    >
                      fas fa-spa
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ data.item.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ data.item.price }} บาท
                      [ {{ data.item.time }} นาที ]
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="time"
                label="เวลาที่ใช้ในการบริการ [นาที]"
                color="orange"
                filled
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="price"
                label="ราคารวม"
                color="orange"
                filled
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="startTime"
                type="time"
                label="เวลาเริ่มต้น"
                color="orange"
                filled
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="endTime"
                type="time"
                label="เวลาสิ้นสุด"
                color="orange"
                filled
                readonly
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="orange"
            @click="createQueue"
          >
            จองคิว
          </v-btn>
          <v-btn
            text
            color="red"
            @click="closeDialog"
          >
            ยกเลิก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="bookDialog"
      max-width="600"
    >
      <v-card>
        <v-card-title>
          เลือกพนักงาน
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="selectedEmployee"
            :items="employees"
            label="พนักงาน"
            filled
            color="orange"
            item-value="_id"
            item-text="firstName"
            item-color="orange"
          >
            <template v-slot:selection="data">
              {{ data.item.firstName }} {{ data.item.lastName }}
            </template>
            <template v-slot:item="data">
              <v-list-item-avatar color="orange">
                <img
                  v-if="data.item.image"
                  :src="data.item.image"
                >
                <v-icon
                  v-else
                  small
                  color="white"
                >
                  fas fa-user
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ data.item.firstName }}
                  {{ data.item.lastName }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
          <v-text-field
            v-model="marks"
            label="หมายเหตุถึงลูกค้า"
            filled
            color="orange"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="orange"
            @click="bookQueue"
          >
            ตกลง
          </v-btn>
          <v-btn
            text
            color="red"
            @click="onQueueDialogClose('bookeDialog')"
          >
            ยกเลิก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="rejectDialog"
    >
      <v-card>
        <v-card-title>
          ปฏิเสธคิว
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="marks"
            label="หมายเหตุถึงลูกค้า"
            filled
            color="orange"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="orange"
            @click="rejectQueue"
          >
            ตกลง
          </v-btn>
          <v-btn
            text
            color="red"
            @click="onQueueDialogClose('rejectDialog')"
          >
            ยกเลิก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="roomDialog"
      max-width="600"
      persistent
    >
      <v-card>
        <v-card-title>
          กรุณาเลือกห้อง
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="selectedRoom"
            label="ห้อง"
            color="orange"
            filled
            :items="rooms"
            item-text="name"
            item-value="_id"
            item-color="orange"
          />
          <v-select
            v-model="selectedBed"
            :disabled="!selectedRoom"
            :items="beds"
            label="เตียง"
            color="orange"
            filled
            item-text="name"
            item-color="orange"
            item-value="_id"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="orange"
            @click="onRoomDialogSubmit"
          >
            ตกลง
          </v-btn>
          <v-btn
            text
            color="error"
            @click="onRoomDialogClose"
          >
            ยกเลิก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import { SET_ALERT, SET_ERROR, SET_ALERT_CONTEXT } from '@/store/mutation_types';
import http from '@/http';

export default {
  name: 'QueueView',
  filters: {
    unixToTime(value) {
      return moment(value).format('HH:mm');
    },
  },
  data() {
    return {
      dateMenu: false,
      date: '',
      employees: [],
      services: [],
      customers: [],
      courses: [],
      selectedEmployee: '',
      lookUpEmployee: '',
      lookUpEmployeeName: '',
      reservationDialog: false,
      selectedCustomer: '',
      selectedService: [],
      selectedCourse: [],
      time: '',
      price: '',
      timeDialog: false,
      startTime: '',
      endTime: '',
      employeePendingQueue: [],
      employeeFinishedQueue: [],
      waitToBookQueue: [],
      selectedQueue: '',
      bookDialog: false,
      rejectDialog: false,
      marks: '',
      rooms: [],
      roomDialog: false,
      selectedRoom: '',
      beds: [],
      selectedBed: '',
      selectedUpdateQueue: '',
    };
  },
  computed: {
    formattedDate() {
      return moment(this.date).format('YYYY-MM-DD');
    },
  },
  watch: {
    selectedService(value) {
      if (value) {
        this.calculate();
      }
    },
    selectedCourse(value) {
      if (value) {
        this.calculate();
      }
    },
    startTime(value) {
      const endTime = moment(`${this.date} ${value}`).add(this.time, 'minutes').format('HH:mm');
      this.endTime = endTime;
    },
    async selectedRoom(value) {
      if (value) {
        const beds = await http.get(`/rooms/${value}?bed_inservice=0`);
        this.beds = [...beds.data.beds];
      }
    },
  },
  async created() {
    const employees = await http.get('/employees?status=ACTIVE');
    this.employees = [...employees.data];
    const services = await http.get('/services?status=ACTIVE');
    this.services = [...services.data];
    const courses = await http.get('/courses?status=ACTIVE');
    this.courses = [...courses.data];
    const customers = await http.get('/customers?status=ACTIVE');
    this.customers = [...customers.data];
    const today = moment().format('YYYY-MM-DD');
    const rooms = await http.get('/rooms?status=ACTIVE');
    this.rooms = [...rooms.data];
    this.date = new Date(today).toISOString().substr(0, 10);
    this.search();
  },
  methods: {
    ...mapActions([SET_ALERT, SET_ERROR, SET_ALERT_CONTEXT]),
    async onSelectEmployee(id, name) {
      this.lookUpEmployee = id;
      this.lookUpEmployeeName = name;
      const start = moment(this.date).valueOf();
      const end = moment(this.date).add(1439, 'minutes').valueOf();
      const { data } = await http.get(`/reservations?employee=${id}&startDate=${start}&endDate=${end}`);
      const employeePendingQueue = [];
      const employeeFinishedQueue = [];
      data.forEach((queue) => {
        if (queue.serviceStatus === 'PENDING') {
          employeePendingQueue.push(queue);
        }
        if (queue.serviceStatus === 'SERVICED') {
          employeeFinishedQueue.push(queue);
        }
      });
      this.employeePendingQueue = [...employeePendingQueue];
      this.employeeFinishedQueue = [...employeeFinishedQueue];
    },
    removeService(id) {
      this.selectedService = this.selectedService.filter(service => service !== id);
    },
    removeCourse(id) {
      this.selectedCourse = this.selectedCourse.filter(course => course !== id);
    },
    calculate() {
      let time = 0;
      let value = 0;
      this.selectedService.forEach((id) => {
        // eslint-disable-next-line
        const service = this.services.find(element => element._id === id);
        time += service.time;
        value += service.price;
      });
      this.selectedCourse.forEach((id) => {
        // eslint-disable-next-line
        const course = this.courses.find(element => element._id === id);
        time += course.time;
        value += course.price;
      });
      this.price = value;
      this.time = time;
    },
    closeDialog() {
      this.selectedEmployee = '';
      this.selectedCustomer = '';
      this.selectedCourse = [];
      this.selectedService = [];
      this.time = '';
      this.price = '';
      this.startTime = '';
      this.endTime = '';
      this.lookUpEmployee = '';
      this.lookUpEmployeeName = '';
      this.reservationDialog = false;
    },
    async createQueue() {
      const data = {
        employee: this.selectedEmployee,
        customer: this.selectedCustomer,
        courses: this.selectedCourse,
        services: this.selectedService,
        time: this.time,
        price: this.price,
        startDate: moment(`${this.date} ${this.startTime}`).valueOf(),
        endDate: moment(`${this.date} ${this.endTime}`).valueOf(),
        reservationStatus: 'APPROVE',
      };
      await http.post('/reservations', data);
      this.SET_ALERT(true);
      this.SET_ERROR(false);
      this.SET_ALERT_CONTEXT('บันทึกการจองแล้ว');
      this.closeDialog();
    },
    async updateQueueStatus(id, type, value) {
      let text = 'อัพเดทสถานะการจองแล้ว';
      await http.put(`/reservations/${id}`, {
        [type]: value,
      });
      if (value === 'PAID') {
        text = 'จ่ายเงินเรียบร้อยแล้ว';
        await http.put(`/beds/reservation/${id}`, {
          inService: false,
          reservationId: null,
        });
      }
      this.SET_ALERT(true);
      this.SET_ERROR(false);
      this.SET_ALERT_CONTEXT(text);
      this.onSelectEmployee(this.lookUpEmployee, this.lookUpEmployeeName);
    },
    onQueueDialogOpen(id, dialogType) {
      this.selectedQueue = id;
      this[dialogType] = true;
    },
    onQueueDialogClose(dialogType) {
      this.selectedQueue = '';
      this.selectedEmployee = '';
      this[dialogType] = false;
      this.marks = '';
    },
    onRoomDialogOpen(queueId) {
      this.roomDialog = true;
      this.selectedUpdateQueue = queueId;
    },
    onRoomDialogClose() {
      this.roomDialog = false;
      this.selectedRoom = '';
      this.selectedBed = '';
      this.beds = '';
      this.selectedUpdateQueue = '';
    },
    async onRoomDialogSubmit() {
      await http.put(`/beds/${this.selectedBed}`, {
        inService: true,
        reservationId: this.selectedUpdateQueue,
      });
      this.updateQueueStatus(this.selectedUpdateQueue, 'serviceStatus', 'SERVICED');
      this.onRoomDialogClose();
    },
    async bookQueue() {
      await http.put(`/reservations/${this.selectedQueue}`, {
        employee: this.selectedEmployee,
        adminMark: this.marks,
        reservationStatus: 'APPROVE',
      });
      this.SET_ALERT(true);
      this.SET_ERROR(false);
      this.SET_ALERT_CONTEXT('อนุมัติการจองนี้แล้ว');
      this.onQueueDialogClose('bookDialog');
      this.search();
    },
    async rejectQueue() {
      await http.put(`/reservations/${this.selectedQueue}`, {
        adminMark: this.marks,
        reservationStatus: 'REJECT',
      });
      this.SET_ALERT(true);
      this.SET_ERROR(false);
      this.SET_ALERT_CONTEXT('ปฏิเสธการจองนี้แล้ว');
      this.onQueueDialogClose('rejectDialog');
      this.search();
    },
    async search() {
      const start = moment(this.date).valueOf();
      const end = moment(this.date).add(1439, 'minutes').valueOf();
      const { data } = await http.get(`/reservations?startDate=${start}&endDate=${end}`);
      this.dateMenu = false;
      this.lookUpEmployee = '';
      this.lookUpEmployeeName = '';
      const waitToBookQueue = [];
      data.forEach((queue) => {
        if (!queue.employee && queue.reservationStatus === 'PENDING') {
          waitToBookQueue.push(queue);
        }
      });
      this.waitToBookQueue = waitToBookQueue;
    },
    async deleteQueue(id) {
      await http.delete(`/reservations/${id}`);
      await this.search();
      this.SET_ALERT(true);
      this.SET_ERROR(false);
      this.SET_ALERT_CONTEXT('ลบการจองแล้ว');
    },
  },
};
</script>
